import styled from 'styled-components';

import theme from '@theme';

export const ResponsiveSearchDrawerItemContent = styled.div<{
  isError?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  height: fit-content;
  box-shadow: ${({ isError }) =>
    isError ? 'inset 0 0 0 3px #d95c5c' : 'none'};

  ${theme.mediaQueries.PHONE} {
    div:last-child {
      border-right: none;
    }
  }
`;
